import _ from "lodash";

import { GrantType } from "prisma/cm/client";
import { isUuid } from "utils/utils";

export * from "./types";

export function getProposedEquityColumnId(grantType: GrantType): string {
  return `proposedGrant${grantType.id}`;
}

export function getSuggestedEquityColumnId(grantType: GrantType): string {
  return `suggestedGrant${grantType.id}`;
}

function isValidEquityFieldId(fieldId: string) {
  const regex =
    /^(proposedGrant|suggestedGrant)[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return regex.test(fieldId);
}

export function isFieldIdRelevantForGrantTypes(fieldId: string, grantTypes: GrantType[]) {
  return _.flatMap(grantTypes, (grantType) => [
    getProposedEquityColumnId(grantType),
    getSuggestedEquityColumnId(grantType),
  ]).includes(fieldId);
}

export function isDynamicField(fieldId: string) {
  return isUuid(fieldId) || isValidEquityFieldId(fieldId);
}
